import Colors from "../Colors";

export const consumables = {
  flask: {
    glyph: {
      fg: Colors.RED_4,
      ch: "X",
    },
    text: {
      name: "Flask of Restoration",
      info:
        "Heals %c{#FF0000} 40%c{} health. Restore uses by resting (%c{#e0c270}z%c{}) at a shrine (%c{#e0c270}_%c{})",
      description:
        "A drink to sooth your wounds and forget the world for a moment. Just don't forget too long or you may never remember",
      logName: "flask",
    },
    mandatory: true,
    usable: {
      uses: 5,
      consumeOnEmpty: false,
      fillOnRest: true,
      stats: {
        health: 40,
      },
    },
  },
} as const;
